import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "contact-container",
  class: "w-full min-h-[calc(100dvh)] h-screen flex flex-col"
}
const _hoisted_2 = { class: "w-full p-10 py-20 sm:py-42 flex-grow flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-12" }, null, -1)
const _hoisted_4 = { class: "max-w-3xl mx-auto w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "font2 text-5xl mb-8 ani-top" }, "Get in touch!", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-red-600 mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"debug\" value=\"1\"><input type=\"hidden\" name=\"debugEmail\" value=\"fabrizio@cieremansvanreijn.nl\"><input type=\"hidden\" name=\"orgid\" value=\"00DUB000004gHDR\"><input type=\"hidden\" name=\"retURL\" value=\"https://zincre.com/\"><label class=\"block font-semibold mb-1 mt-4\">Name *</label>", 5)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold mb-1 mt-4" }, "Email *", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold mb-1 mt-4" }, "Phone number", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold mb-1 mt-4" }, "Subject *", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold mb-1 mt-4" }, "Description *", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold mb-1 mt-4" }, "What is your issue about? *", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "--Make a selection--", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", null, "Repair Request", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", null, "Billing Question", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", null, "Complaint", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", null, "Other", -1)
const _hoisted_22 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold mb-1 mt-4" }, "What best describes the issue? *", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "--Make a selection--", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full mt-6 bg-gray-800 text-white rounded py-3 hover:bg-gray-700 transition"
}, " Submit ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        ($setup.errors.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errors, (error) => {
                return (_openBlock(), _createElementBlock("li", { key: error }, "• " + _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          form: "",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"])),
          action: "https://zincre--partial.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8&orgId=00DUB000004gHDR",
          method: "POST",
          class: "w-full ani-top bg-white shadow rounded-xl p-8"
        }, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.name) = $event)),
            name: "name",
            type: "text",
            class: _normalizeClass([
                    'w-full border rounded px-3 py-2',
                    $setup.hasError('name') ? 'border-red-500' : 'border-gray-300'
                    ])
          }, null, 2), [
            [_vModelText, $setup.name]
          ]),
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event)),
            name: "email",
            type: "email",
            class: _normalizeClass([
                    'w-full border rounded px-3 py-2',
                    $setup.hasError('email') ? 'border-red-500' : 'border-gray-300'
                    ])
          }, null, 2), [
            [_vModelText, $setup.email]
          ]),
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.phone) = $event)),
            name: "phone",
            type: "tel",
            class: "w-full border border-gray-300 rounded px-3 py-2"
          }, null, 512), [
            [_vModelText, $setup.phone]
          ]),
          _hoisted_14,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.subject) = $event)),
            name: "subject",
            type: "text",
            class: _normalizeClass([
                    'w-full border rounded px-3 py-2',
                    $setup.hasError('subject') ? 'border-red-500' : 'border-gray-300'
                    ])
          }, null, 2), [
            [_vModelText, $setup.subject]
          ]),
          _hoisted_15,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.description) = $event)),
            name: "description",
            class: _normalizeClass([
                    'w-full border rounded px-3 py-2 resize-y',
                    $setup.hasError('description') ? 'border-red-500' : 'border-gray-300'
                    ])
          }, null, 2), [
            [_vModelText, $setup.description]
          ]),
          _hoisted_16,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedType) = $event)),
            name: "type",
            class: _normalizeClass([
                    'w-full border rounded px-3 py-2',
                    $setup.hasError('Issue') ? 'border-red-500' : 'border-gray-300'
                    ])
          }, _hoisted_22, 2), [
            [_vModelSelect, $setup.selectedType]
          ]),
          ($setup.subtypes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedSubtype) = $event)),
                  name: "00NWy000000c3p5",
                  class: _normalizeClass([
                        'w-full border rounded px-3 py-2',
                        $setup.hasError('type') ? 'border-red-500' : 'border-gray-300'
                        ])
                }, [
                  _hoisted_25,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.subtypes, (subtype) => {
                    return (_openBlock(), _createElementBlock("option", { key: subtype }, _toDisplayString(subtype), 1))
                  }), 128))
                ], 2), [
                  [_vModelSelect, $setup.selectedSubtype]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_26
        ], 32)
      ])
    ])
  ]))
}